<template>
    <div>
        <b-modal ref="modal" hide-footer size="xl">
            <template v-slot:modal-title>
				{{ $t("action.importer") }}
			</template>
            <div v-if="formError == false">
                <b-form-textarea
                    v-if="!importModal"
                    id="textarea"
                    v-model="text"
                    placeholder="Enter something..."
                    rows="10">
                </b-form-textarea>
                <div class="text-center my-2">
                    <b-button v-if="!importModal" variant="primary" @click="handleData()">{{$t('tiers.tiers_import.tiers_importer')}}</b-button>
                </div>
                <Import v-if="importModal" :form.sync="form" :numberOfSelect.sync="numberOfSelect" :options="options" @clicked="importData($event)"/>
            </div>
            <div v-else>
                <h4 v-if="!hasVATFr" class="text-danger text-center">
                    {{ $t("tiers.tiers_import.error_message") }}
                </h4>
                <h4 v-else class="text-success text-center">
                    {{ $t("tiers.ask_pappers_message") }}
                </h4>
                <table class="table text-center">
                    <thead>
                        <tr>
                            <th scope="col">   
                                {{$t('tiers.tiers_import.tiers_rs')}}
                            </th>
                            <th scope="col">   
                                {{$t('tiers.tiers_import.tiers_firstname')}}
                            </th>
                            <th scope="col">   
                                {{$t('tiers.tiers_import.tiers_lastname')}}
                            </th>
                            <th scope="col">
                                {{$t('tiers.avertissement')}}
                            </th>
                            <th v-if="hasVATFr" scope="col">
                                {{$t('tiers.update_tiers_pappers')}}
                            <b-form-checkbox
                                v-model="selectAll"
                                @change="toggleAll"
                            />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ligne, i) in FormToDownload" :key="i">
                            <td scope="col">
                               {{FormToDownload[i].tiers_rs}}
                            </td>
                            <td scope="col">
                               {{FormToDownload[i].tiers_firstname}}
                            </td>
                            <td scope="col">
                               {{FormToDownload[i].tiers_lastname}}
                            </td>
                            <td scope="col">
                                <span v-for="error in FormToDownload[i].errors" :key="error">
                                    {{ error }} <br>
                                </span> 
                            </td>
                            <td scope="col">
                                <b-form-checkbox
                                    v-if="FormToDownload[i].tva_fr"
                                    class="custom-control"
                                    v-model="FormToDownload[i].ask_pappers" 
                                    name="check-button"
                                    @change="checkIfAllSelected"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="text-center">
                    <b-button variant="secondary" class="mr-2" @click="closeModal">{{$t('tiers.ignorer')}}</b-button>
                    <b-button v-if="hasVATFr" variant="primary" @click="askPappers"><font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse />{{$t('tiers.bouton_update_tiers_pappers')}}</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script type="text/javascript">
    import Navigation from "@/mixins/Navigation.js"
    import Tiers from "@/mixins/Tiers.js"
    import Tools from "@/mixins/Tools.js"
    import _deepClone from 'lodash/cloneDeep'
    import Countries from 'GroomyRoot/assets/lang/countries/countries'
    import Indicatif from 'GroomyRoot/assets/lang/countries/indicatif'
    import Vue from 'vue'

    export default {
        name: "TiersImport",
        mixins: [Navigation, Tiers, Tools],
        data () {
            return {
                selectAll: true,
                formError: false,
                processing: false,
                FormToDownload: {},
                indicatifs: {},
				countries: {},
				countries_iso: {},
                importModal: false,
                options: [
                    { value: '0', text: this.getTrad('tiers.tiers_import.tiers_rs'), column: 'tiers_rs', requis: false },
                    { value: '1', text: this.getTrad('tiers.tiers_import.tiers_firstname'), column: 'tiers_firstname', requis: false},
                    { value: '2', text: this.getTrad('tiers.tiers_import.tiers_lastname'), column: 'tiers_lastname', requis: false },
                    { value: '3', text: this.getTrad('tiers.tiers_import.tiers_civility'), column: 'tiers_civility', requis: false },
                    { value: '4', text: this.getTrad('tiers.tiers_import.tier_phone') + ' 1', column: 'phone', requis: false},
                    { value: '5', text: this.getTrad('tiers.tiers_import.tiers_mail'), column: 'tiers_mail', requis: false },
                    { value: '6', text: this.getTrad('tiers.tiers_import.tiers_alias'), column: 'tiers_alias', requis: false },
                    { value: '7', text: this.getTrad('tiers.tiers_import.tiers_address1'), column: 'tiers_address1', requis: false },
                    { value: '8', text: this.getTrad('tiers.tiers_import.tiers_address2'), column: 'tiers_address2', requis: false },
                    { value: '9', text: this.getTrad('tiers.tiers_import.tiers_postalcode'), column: 'tiers_postalcode', requis: false },
                    { value: '10', text: this.getTrad('tiers.tiers_import.tiers_town'), column: 'tiers_town', requis: false },
                    { value: '11', text: this.getTrad('tiers.tiers_import.tiers_country'), column: 'tiers_country', requis: false},
                    { value: '12', text: this.getTrad('tiers.tiers_import.tiers_website'), column: 'tiers_website', requis: false},
                    { value: '14', text: this.getTrad('tiers.tiers_import.tiers_moral'), column: 'tiers_moral', requis: false },
                    { value: '15', text: this.getTrad('tiers.tiers_import.tiers_lang'), column: 'tiers_lang', requis: false},
                    { value: '16', text: this.getTrad('tiers.tiers_import.tiers_client_account'), column: 'tiers_client_account', requis: false},
                    { value: '17', text: this.getTrad('tiers.tiers_import.tiers_vat_number'), column: 'tiers_vat_number', requis: false},
                    { value: '18', text: this.getTrad('tiers.tiers_import.tiers_region'), column: 'tiers_region', requis: false},
                    { value: '19', text: this.getTrad('tiers.tiers_import.tier_phone') + ' 2', column: 'phone_2', requis: false},
                    { value: '20', text: this.getTrad('tiers.tiers_import.tiers_siret'), column: 'tiers_siret', requis: false},
                    { value: '21', text: this.getTrad('tiers.tiers_import.tiers_siren'), column: 'tiers_siren', requis: false},
                    { value: 'null', text: this.getTrad('global.ne_pas_importer'), column: 'null', requis: false}
                ],
                default_form: {
                    tiers_rs: '',
                    tiers_firstname: '',
                    tiers_lastname: '',
                    tiers_civility: '',
                    tiers_mail: '',
                    tiers_alias: '',
                    tiers_address1: '',
                    tiers_address2: '',
                    tiers_postalcode: '',
                    tiers_town: '',
                    tiers_country: '',
                    tiers_website: '',
                    tiers_entity: false,
                    tiers_moral: false,
                    tiers_currency: 'EUR',
                    tiers_lang: 'fr',
                    tiers_vat_number: '',
                    tiers_region: '',
                    tiers_siren: '',
                    tiers_siret: '',
                    tva_fr: '',
                    phones: []
                },
                numberOfSelect: 0,
                form: [],
                text: "",
                events_tab: {
                    'TableAction::goToImportTiers': () => {
                        this.showModal()
                    },
                },
            }
        },
        created() {
			this.indicatifs = Indicatif
			this.countries = Countries[Vue.i18n.locale()].label
			this.countries_iso = Countries[Vue.i18n.locale()].iso_3
        },
        methods: {
            async showModal() {
                this.$refs['modal'].show()
                this.text = ""
                this.importModal = false
                this.form = []
            },
            async handleData() {
                if(this.text == "" || this.text == null){
                    return
                }
                const wordByspace = this.text.split('\n').filter(w => !!w)
                for (const [i, elements] of wordByspace.entries()) {
                    const words = elements.split('\t')
                    let obj = {}
                    obj.checked = true
                    this.numberOfSelect = 0
                    for (const [j, word] of words.entries()) {
                        this.numberOfSelect++
                        obj[j] = word
                    }
                    this.$set(this.form, i, obj)
                }
                this.importModal = true
            },

            async importData(event){
                const final_form = []
                let ID_Tiers = 0
                for (const tiers of event) {
                    let errors = []
                    const form = _deepClone(this.default_form)
                    
                    for (const [key, value] of Object.entries(tiers)){
                        form[key] = value
                    }
                    let phone_Indicatif = ''
                    let phone_Country = ''
                    let phone_Type = ''
                    const inverted_countries_iso  = Object.fromEntries(Object.entries(this.countries_iso).map(([k, v]) => [v, k]))
                    // Vérification SIRET
                    if (form['tiers_siret'] && form['tiers_siret'] !== "") {
                        if (!this.checkSiret(form['tiers_siret'])) { 
                            errors.push(this.getTrad('tiers.tiers_import.siret_non_conforme', [form['tiers_siret']]))
                        } 
                        else {
                            const sirenFromSiret = form['tiers_siret'].substring(0, 9)

                            if (!form['tiers_siren'] || form['tiers_siren'].trim() === "") {
                                // SIREN vide → on le déduit et on avertit
                                form['tiers_siren'] = sirenFromSiret
                                errors.push(this.getTrad('tiers.tiers_import.siren_vide_auto_remplissage', [sirenFromSiret]))
                            } 
                            else if (!this.checkSiren(form['tiers_siren'])) {
                                // SIREN invalide → on le remplace par celui du SIRET
                                errors.push(this.getTrad('tiers.tiers_import.siren_non_conforme_auto_replace', [form['tiers_siren'], sirenFromSiret]))
                                form['tiers_siren'] = sirenFromSiret
                            } 
                            else if (form['tiers_siren'] !== sirenFromSiret) {
                                // SIREN valide mais ≠ au SIRET → corriger + avertir
                                errors.push(this.getTrad('tiers.tiers_import.siren_not_match_siret_auto_replace', [form['tiers_siren'], sirenFromSiret]))
                                form['tiers_siren'] = sirenFromSiret
                            }
                        }
                    }
                    
                    //Vérification SIREN (après traitement)
                    //Ici, normalement, il est soit conforme soit remplacé par le bon
                    if (form['tiers_siren'] && form['tiers_siren'] !== "" && !this.checkSiren(form['tiers_siren'])) {
                        errors.push(this.getTrad('tiers.tiers_import.siren_non_conforme', [form['tiers_siren']]));
                    }

                    // tiers_country
                    const formCountry = Object.values(this.countries_iso).find((country) => (country == (form['tiers_country'])))
                    if (formCountry != undefined){
                        phone_Indicatif = this.indicatifs[form['tiers_country']]
                        form['tiers_country'] = inverted_countries_iso[form['tiers_country']]
                        phone_Country = form['tiers_country']
                    }
                    else {
                        const defaultCountry = this.getConfig('country', '75')
                        phone_Country = defaultCountry
                        phone_Indicatif = this.indicatifs[inverted_countries_iso[defaultCountry]]
                        if( form['tiers_country'] != ''){
                            errors.push('le nom de pays -> "' + form['tiers_country']+ '" n\'est pas reconnu')
                        }
                        form['tiers_country'] = defaultCountry
                    }

                    //tiers_lang
                    const formLang = Object.values(this.countries_iso).find((country) => (country == (form['tiers_country'])))
                    if (formLang != undefined){
                        phone_Indicatif = this.indicatifs[form['tiers_lang']]
                        form['tiers_lang'] = inverted_countries_iso[form['tiers_lang']]
                    }
                    
                    //Insertion téléphone
                    if(form.phone) {
                        const phoneNumber = form.phone.split('/')
                        for(let phone of phoneNumber){
                            phone = phone.replace(' ', '').replace('.', '')
                            if (phone[phone.length - 9] == '7' || phone[phone.length - 9] == '6'){
                                phone_Type = 'portable'
                            }
                            else{
                                phone_Type = 'fixe'
                            }

                            form.phones.push({
                                phone_indicatif: phone_Indicatif, 
                                phone_numero: phone,
                                phone_type: phone_Type,
                                phone_country: phone_Country
                            })
                        }
                    }

                    if(form.phone_2) {
                        const phoneNumber = form.phone_2.split('/')
                        for(let phone of phoneNumber){
                            phone = phone.replace(' ', '').replace('.', '')
                            if (phone[phone.length - 9] == '7' || phone[phone.length - 9] == '6'){
                                phone_Type = 'portable'
                            }
                            else{
                                phone_Type = 'fixe'
                            }

                            form.phones.push({
                                phone_indicatif: phone_Indicatif, 
                                phone_numero: phone,
                                phone_type: phone_Type,
                                phone_country: phone_Country
                            })
                        }
                    }

                    form.tiers_civility = this.formatCivility(form.tiers_civility)

                    if( form.tiers_rs && form.tiers_rs != ''){
                        form.tiers_moral = true
                    }
                    this.FormToDownload[ID_Tiers] = form
                    if (errors.length != 0) {
                        this.FormToDownload[ID_Tiers].errors = errors
                    }
                    if(this.checkTvaFR(form.tiers_vat_number) || this.checkSiret(form.tiers_siret)) {
                        this.FormToDownload[ID_Tiers].tva_fr = true
                        this.FormToDownload[ID_Tiers].ask_pappers = true
                    }
                    final_form.push(form)
                    ID_Tiers++
                } 
                try {
                    const result = await this.importTier(final_form)
                    const incorrectVatTiers = result.filter((tier) => tier.tiers_vatcheck == 2)
                    if (incorrectVatTiers.length > 0) {
                        this.infoToast("toast.import_tiers_vatcheck")
                    }

                    result.forEach((tiers, index) => {
                        this.FormToDownload[index].tiers_id = tiers.tiers_id
                    })
                }
                catch (e) {
                    console.error(e)
                }

                if(Object.keys(this.FormToDownload).length > 0){
                    this.formError = true
                    await this.$sync.runOptionalWhishlist(['tiers'])
                    return
                }

                await this.$sync.runOptionalWhishlist(['tiers'])
                this.$refs['modal'].hide()
            },

            formatCivility(civilityToCheck){
                const allowedCivilities = [ "m", "mme", "dr", "cte", "ctesse", "pr", "me", "aud", "vte", "vtesse", "m.mme" ]
                let finalCivility = "";
                for(let i = 0; i < allowedCivilities.length; i++) {
                    const civility = allowedCivilities[i]
                    if(civilityToCheck == this.getTrad('civility.' + civility).toLowerCase() || civilityToCheck == this.getTrad('civility_complete.' + civility).toLowerCase()) {
                        finalCivility = civility
                        break;
                    }
                }
                return finalCivility
            },

            closeModal(){
                this.$refs['modal'].hide()
                this.formError = false
                this.FormToDownload = {}
            },

            async askPappers(){
                this.processing = true
                const tiers_ids = Object.values(this.FormToDownload).filter(tiers => tiers.ask_pappers).map(tiers => tiers.tiers_id)
                await this.updatePappers(tiers_ids)
                this.closeModal()
                this.successToast("tiers.success_toast_pappers")
                this.processing = false
            },
            checkTvaFR(tva){
                if (!tva) return false
                return tva.trim().substring(0, 2).toLowerCase() == 'fr'
            },
            toggleAll(val) {
                Object.values(this.FormToDownload).forEach(item => {
                    item.ask_pappers = val
                })
            },
            checkIfAllSelected(val) {
                this.$nextTick(() => {
                    this.selectAll = Object.values(this.FormToDownload).filter(tiers => tiers.ask_pappers).length == Object.values(this.FormToDownload).length
                })
            }
        },
        computed: {
            hasVATFr() {
                return Object.values(this.FormToDownload).filter(f => f.tva_fr).length > 0
            }
        },
        components: {
            LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
            ErrorAlert: () => import('GroomyRoot/components/Alert/ErrorAlert'),
            Import: () => import('@/components/Utils/Import'),
        }
    }
</script>
